export const getshopperSendResponse = state => state.shopperContent.shopperSendResponse;
export const getShopperStatus = state => state.shopperContent.status;
